import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleOnClickLogout, getUserPackage } from "../constants";
import {
  NavBar,
  SideBar,
  Breadcrumb,
  SettingAccount,
  SettingPackage,
} from "../components";
import { ToastContainer } from "react-toastify";

const Home = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const [packageData, setPackageData] = useState(user.package);
  const [breads, setBreads] = useState(["Setting"]);

  const [loading, setLoading] = useState(false);

  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };

  const addBreadCrumb = (crumb) => {
    setBreads(["Setting", crumb]);
  };

  useEffect(() => {
    getUserPackage(token, setPackageData);
    if (tab && tab.toLocaleLowerCase() == "account") {
      setBreads(["Setting", "Account"]);
    } else if (tab && tab.toLocaleLowerCase() == "package") {
      setBreads(["Setting", "Package Plan"]);
    }
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <ToastContainer />
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={breads[0].toLocaleLowerCase()} />
        <div className="flex flex-col w-full bg-red-100">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center ">
            <div className="flex flex-col md:flex-row w-full h-full bg-white overflow-y-auto pb-40 md:pb-0">
              <div className="hidden md:flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-1/5 px-5 py-5 gap-3 text-black">
                <div
                  className={`flex flex-row items-center gap-2 pb-3 cursor-pointer hover:font-bold w-full active:font-semibold ${
                    breads[breads.length - 1] == "Account" ? "font-bold" : ""
                  }`}
                  onClick={(e) => addBreadCrumb("Account")}
                >
                  Account
                </div>
                <div
                  className={`flex flex-row items-center gap-2 pb-3 cursor-pointer hover:font-bold w-full active:font-semibold ${
                    breads[breads.length - 1] == "Package Plan"
                      ? "font-bold"
                      : ""
                  }`}
                  onClick={(e) => addBreadCrumb("Package Plan")}
                >
                  Package Plan
                </div>
              </div>
              <form className="flex flex-col w-full md:hidden p-5">
                <select
                  id="settings"
                  className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-5 py-3"
                  onChange={(e) => addBreadCrumb(e.target.value)}
                >
                  <option disabled selected={breads.length == 1}>
                    -- Select an option --
                  </option>
                  <option
                    value={"Account"}
                    selected={breads[breads.length - 1] == "Account"}
                  >
                    Account
                  </option>
                  <option
                    value={"Package Plan"}
                    selected={breads[breads.length - 1] == "Package Plan"}
                  >
                    Package Plan
                  </option>
                </select>
              </form>
              <div className="flex flex-col border-0 border-r-2 border-gray-200 w-full p-5">
                {breads[breads.length - 1] == "Account" ? (
                  <SettingAccount token={token} />
                ) : breads[breads.length - 1] == "Package Plan" ? (
                  <SettingPackage token={token} packageData={packageData} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
